import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '../biLogger';
import PollAnswers from './PollAnswers';
import s from './PollView.actionbarrr.scss';
var PollView = function (_a) {
    var poll = _a.deviation.poll, onVote = _a.onVote, canVote = _a.canVote, className = _a.className, minimal = _a.minimal, draftJsThemeOverride = _a.draftJsThemeOverride, answerClassName = _a.answerClassName;
    var t = useTranslation().t;
    if (!poll) {
        return null;
    }
    var classNames = classnames(s['root'], minimal && s['minimal'], className);
    return (React.createElement(BiLoggerContextProvider, { value: { pollid: poll.pollId } },
        React.createElement("div", { className: classNames },
            !minimal && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: s['question'] }, poll.question),
                React.createElement("div", { className: s['info'] },
                    React.createElement("span", { className: s['votes'] }, t('pollView.votes', { count: poll.votes }))))),
            React.createElement(PollAnswers, { poll: poll, canVote: canVote, onVote: onVote, draftJsThemeOverride: draftJsThemeOverride, answerClassName: answerClassName }))));
};
PollView.displayName = 'PollView';
export default PollView;
//# sourceMappingURL=PollView.actionbarrr.js.map